import { IStore } from '../common/types/IStore'

const getUserStore = (): IStore => {
  const userStore = localStorage.getItem('USER_STORE')
  return userStore !== null
    ? (JSON.parse(userStore) as IStore)
    : ({ storeId: 0, storeCode: '', storeName: '' } as IStore)
}

const setUserStore = (store: IStore) =>
  localStorage.setItem('USER_STORE', JSON.stringify(store))

const setCurrentPlanner = (planner: string) =>
  localStorage.setItem('CURRENT_PLANNER', planner)

const getCurrentPlanner = () => localStorage.getItem('CURRENT_PLANNER')

const checkStore = (store: IStore | undefined): string => {
  if (!store) {
    return 'Store is not defined'
  }

  if (store.storeId === undefined) {
    return 'StoreId is not defined'
  }

  if (store.storeId === null) {
    return 'StoreId is null'
  }

  switch (store.storeId) {
    case 0:
      return 'StoreId is currently set to 0'
    default:
      return ''
  }
}

export {
  checkStore,
  getCurrentPlanner,
  getUserStore,
  setCurrentPlanner,
  setUserStore,
}
